<template>
  <div class="loading-overlay" role="status" aria-live="polite" aria-busy="true">
    <div class="loading-message">
      <p class="loading-title">{{ title }}</p>
      <p class="loading-subtitle">{{ subtitle }}</p>
      <i class="fas fa-spinner fa-spin"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingMessage',
  props: {
    title: {
      type: String,
      default: 'Cargando...',
    },
    subtitle: {
      type: String,
      default: 'Esto podría tardar unos segundos.',
    },
  },
};
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-message {
  background-color: white;
  padding: 20px 40px;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  max-width: 460px;
}

.loading-title {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 8px;
  color: #2c3e50;
}

.loading-subtitle {
  margin-bottom: 0;
  color: #5c6b7a;
  line-height: 1.5;
}

.fa-spinner {
  margin-top: 14px;
  font-size: 24px;
  color: #3498db;
}
</style>
